import React from "react";
import cx from "classnames";
import "./styles.scss";

type DrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

const Drawer: React.FC<DrawerProps> = ({
  isOpen,
  onClose,
  children,
}: DrawerProps): React.ReactElement => {
  return (
    <>
      {/* Overlay/Backdrop */}
      <div
        className={cx(
          [
            "julia-website-drawer-overlay",
            "u-height-full",
            "u-left-0",
            "u-position-fixed",
            "u-top-0",
            "u-width-full",
            "u-z-index-102",
          ],
          {
            "is-open": isOpen,
            "is-closed": !isOpen,
          },
        )}
        onClick={onClose}
        onKeyDown={(e) => {
          if (e.key === "Escape") onClose();
        }}
        role="button"
        tabIndex={isOpen ? 0 : -1}
        aria-label="Close drawer"
      />

      {/* Drawer Panel */}
      <div
        className={cx(
          [
            "julia-website-drawer",
            "u-background-color-drawer",
            "u-height-full",
            "u-position-fixed",
            "u-right-0",
            "u-top-0",
            "u-z-index-103",
          ],
          {
            "is-open": isOpen,
            "is-closed": !isOpen,
          },
        )}
      >
        {/* Drawer content */}
        <div>{children}</div>
      </div>
    </>
  );
};

export default React.memo(Drawer);
